import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* Reset default browser styling */
  body {
    font-family: 'Nunito', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; // Use a more modern font
    color: #333;
    background-color: #F4F7FA;
    font-smooth: always;
    -webkit-font-smoothing: antialiased;
  }
  html, body, #root {
      height: 100%;
  }

  html,  div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  ol, ul {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: inherit; 
  }


  img {
    max-width: 100%;
    height: auto;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }


  .container {
    max-width: 1140px;
    margin: 0 auto;
    padding: 0 15px;
  }

  
  .column-wide {
    width: 300px;  /* Wider column width */
}

.column-normal {
    width: 150px;  /* Normal column width */
}
  .modal-overlay {
      background-color: rgba(0, 0, 0, 0.5);
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1100;
  }

  .modal-content {
      position: relative;
      outline: none;
      border: none;
      background: transparent;
  }


  /* Responsive text and components */
  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
  }

  @media (max-width: 576px) {
    html {
      font-size: 13px; 
    }
  }
`;




export default GlobalStyle;
